import api from '@/services/apiService';

export interface SportPreferencesResponse {
  data: {
    categories: string[];
    level: string;
    goals: string[];
  };
  message: string;
  success: boolean;
}

export interface SportPreferencePayload {
  // categories are backend slugs like 'mini-soccer', 'futsal'
  categories: string[];
  level: string; // 'beginner' | 'intermediate' | 'advanced'
  goals: string[];
}

const getSportPreferences = async (): Promise<SportPreferencesResponse> => {
  const response = await api.get(`/client/sport-preferences`);
  return response.data;
};

const updateSportPreferences = async (payload: SportPreferencePayload) => {
  const response = await api.put(`/client/sport-preferences`, payload);
  return response.data;
};

export { getSportPreferences, updateSportPreferences };
